import { useEffect, useMemo, useState } from "react";

// Paginação em memória para as tabelas dentro dos formulários
const usePaginacaoLocal = <T>(dados: T[], itensPorPagina: number = 5) => {
  const [paginaAtual, setPaginaAtual] = useState(1);

  const totalPaginas = Math.max(1, Math.ceil(dados.length / itensPorPagina));

  // Mantém a página atual dentro do total (ex.: após excluir o último item da página)
  useEffect(() => {
    if (paginaAtual > totalPaginas) {
      setPaginaAtual(totalPaginas);
    }
  }, [paginaAtual, totalPaginas]);

  const itensPagina = useMemo(
    () =>
      dados.slice(
        (paginaAtual - 1) * itensPorPagina,
        paginaAtual * itensPorPagina
      ),
    [dados, paginaAtual, itensPorPagina]
  );

  return { itensPagina, paginaAtual, totalPaginas, setPaginaAtual };
};

export default usePaginacaoLocal;
